/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class FilterIcon extends BaseIcon {
    getChildren = () => [<path fill={this.getColor()} d="M13,3L9,9v5H7V9L3,3H13z"/>]
    getViewBox = () => '0 0 16 16'
}
